import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Importação para o redirecionamento
import Menu from '../../comum/Menu/index.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { Modal, Button, Form, Badge, Card, Table } from 'react-bootstrap';
import { api } from '../../services/api.js';

const fotoCache = new Map();
const usuario = localStorage.getItem("chapa");

// --- Subcomponente para o Card ---
const ComunicadoCard = ({ item, onClick }) => {
    const [foto, setFoto] = useState(null);

    useEffect(() => {
        const hoje = new Date().toISOString().slice(0, 10);
        const chave = `${item.chapa}_${hoje}`;

        if (fotoCache.has(chave)) {
            setFoto(fotoCache.get(chave));
        } else {
            api.get(`/usuario/foto/${item.chapa}`)
                .then(res => {
                    fotoCache.set(chave, res.data.foto);
                    setFoto(res.data.foto);
                })
                .catch(() => console.log("Erro ao buscar foto"));
        }
    }, [item.chapa]);

    return (
        <Card className="shadow-sm h-100 mb-3" onClick={() => onClick(item, foto)} style={{ cursor: 'pointer', borderLeft: '5px solid #007bff' }}>
            <div className="d-flex p-3 align-items-center">
                <img 
                    src={foto ? `data:image/jpeg;base64,${foto}` : 'https://via.placeholder.com/60'} 
                    alt="Foto"
                    className="rounded-circle me-3"
                    style={{ width: '60px', height: '60px', objectFit: 'cover', border: '2px solid #eee' }}
                />
                <div style={{ flex: 1 }}>
                    <div className="d-flex justify-content-between align-items-start">
                        <Badge bg="primary" className="mb-1">{item.tipo}</Badge>
                        <small className="text-muted" style={{fontSize: '0.7rem'}}>{new Date(item.hora).toLocaleDateString()}</small>
                    </div>
                    <div className="fw-bold text-uppercase" style={{ fontSize: '0.85rem' }}>{item.nome}</div>
                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                        Matrícula: {item.chapa} <br/>
                        <strong>Loja: {item.filial} ➔ <span className="text-danger">{item.lojades}</span></strong>
                    </div>
                </div>
            </div>
        </Card>
    );
};

// --- Componente Principal ---
function AprovacaoComunicado() {
    const navigate = useNavigate(); // Hook para navegação
    const [comunicados, setComunicados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [showAvaliar, setShowAvaliar] = useState(false);
    const [showLog, setShowLog] = useState(false);
    
    const [selected, setSelected] = useState(null);
    const [fotoSelected, setFotoSelected] = useState(null);
    const [logs, setLogs] = useState([]);
    const [motivo, setMotivo] = useState("");

    // --- Verificação de Permissão ---
    useEffect(() => {
        const permiteRegional = localStorage.getItem("permiteRegional");
        if (permiteRegional !== "S") {
            alert("SEM PERMISSÃO AO ACESSO AO MÓDULO");
            navigate("/arbor/home");
        } else {
            loadComunicados(); // Só carrega os dados se tiver permissão
        }
    }, [navigate]);

    const loadComunicados = async () => {
        setLoading(true);
        try {
            const response = await api.get('/usuario/comunicacao/1');
            setComunicados(response.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenDetails = (item, foto) => {
        setSelected(item);
        setFotoSelected(foto);
        setShowDetails(true);
    };

    const fetchLogs = async (codigo) => {
        setLoading(true);
        try {
            const response = await api.get(`/usuario/comunicacao/log/${codigo}`);
            setLogs(response.data);
            setShowLog(true);
        } catch (err) {
            alert("Erro ao buscar logs");
        } finally {
            setLoading(false);
        }
    };

    const handleAction = (statusAcao) => {
        setLoading(true);
        const payload = {
            codigo: selected.cod_operacao,
            status: statusAcao,
            usuario,
            operacao: String(selected.tipooperacao),
            observacao: motivo,
            autorizado: "1"
        };

        api.post('/usuario/comunicacao', payload)
            .then(() => {
                setShowAvaliar(false);
                setShowDetails(false);
                setMotivo("");
                loadComunicados();
            })
            .catch(err => alert("Erro: " + err.message))
            .finally(() => setLoading(false));
    };

    const formatMoeda = (valor) => valor ? valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';

    return (
        <div>
            <Menu modulo="ARBOR" />
            
            <div className="container mt-4 mb-5">
                <h4 className="mb-4 text-primary border-bottom pb-2">Pendências de RH</h4>
                <div className="row">
                    {comunicados.map(item => (
                        <div className="col-lg-4 col-md-6" key={item.cod_operacao}>
                            <ComunicadoCard item={item} onClick={handleOpenDetails} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal de Detalhes */}
            <Modal show={showDetails} onHide={() => setShowDetails(false)} size="lg" centered>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title>Avaliação de Comunicado</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selected && (
                        <div className="row">
                            <div className="col-md-4 text-center border-end">
                                <img 
                                    src={fotoSelected ? `data:image/jpeg;base64,${fotoSelected}` : 'https://via.placeholder.com/150'} 
                                    className="img-fluid rounded shadow-sm mb-3" alt="User"
                                />
                                <h6 className="mb-1">{selected.nome}</h6>
                                <p className="text-muted small">Solicitado em: {new Date(selected.hora).toLocaleString()}</p>
                                <Button variant="outline-secondary" size="sm" className="w-100 mt-2" onClick={() => fetchLogs(selected.cod_operacao)}>
                                   📜 VER LOGS
                                </Button>
                            </div>
                            <div className="col-md-8">
                                <div className="row mb-3">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Loja Atual</label>
                                        <div className="fw-bold">{selected.filial}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Loja Destino</label>
                                        <div className="fw-bold text-danger">{selected.lojades}</div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Setor Atual</label>
                                        <div className="fw-bold">{selected.setor}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Novo Setor</label>
                                        <div className="fw-bold text-danger">{selected.descsetornovo || '--'}</div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Função Atual</label>
                                        <div className="fw-bold">{selected.funcao}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Nova Função</label>
                                        <div className="fw-bold text-danger">{selected.descfuncnova || '--'}</div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Salário Atual</label>
                                        <div className="fw-bold">{formatMoeda(selected.salario)}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Novo Salário</label>
                                        <div className="fw-bold text-danger">{formatMoeda(selected.salarionovo)}</div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Horário Atual</label>
                                        <div className="small" style={{lineHeight: '1.2'}}>{selected.deschorario}</div>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-muted small d-block">Novo Horário</label>
                                        <div className="small text-danger fw-bold" style={{lineHeight: '1.2'}}>{selected.deschorarionovo || '--'}</div>
                                    </div>
                                </div>
                                <div className="mt-2 p-2 bg-light border rounded">
                                    <label className="text-muted small">Data Efetiva da Mudança:</label>
                                    <div className="fw-bold text-danger">{new Date(selected.dataefetivo).toLocaleDateString()}</div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className="px-4" onClick={() => setShowAvaliar(true)}>AVALIAR OPERAÇÃO</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de LOGS */}
            <Modal show={showLog} onHide={() => setShowLog(false)} size="lg" centered scrollable>
                <Modal.Header closeButton className="bg-dark text-white">
                    <Modal.Title>Histórico de Operações</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive size="sm">
                        <thead className="table-dark">
                            <tr>
                                <th>Data/Hora</th>
                                <th>Usuário</th>
                                <th>Status</th>
                                <th>Autorização</th>
                                <th>Obs</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: '0.85rem' }}>
                            {logs.map((l, index) => (
                                <tr key={index}>
                                    <td>{new Date(l.hora).toLocaleString()}</td>
                                    <td>{l.nome} <br/><small className="text-muted">{l.usuario}</small></td>
                                    <td><Badge bg="info">{l.descstatus}</Badge></td>
                                    <td>{l.autorizado}</td>
                                    <td>{l.observacaolog || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>

            {/* Modal de Decisão */}
            <Modal show={showAvaliar} onHide={() => setShowAvaliar(false)} centered>
                <Modal.Header closeButton className="bg-warning text-dark">
                    <Modal.Title>Concluir Avaliação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="fw-bold">Observações / Motivo:</Form.Label>
                        <Form.Control as="textarea" rows={3} value={motivo} onChange={e => setMotivo(e.target.value)} autoFocus />
                        <Form.Text className="text-muted">Campo obrigatório para prosseguir.</Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button variant="danger" className="px-4" onClick={() => handleAction(12)} disabled={!motivo || loading}>NEGAR</Button>
                    <Button variant="success" className="px-4" onClick={() => handleAction(2)} disabled={!motivo || loading}>APROVAR</Button>
                </Modal.Footer>
            </Modal>

            <Footer />
        </div>
    );
}

export default AprovacaoComunicado;